import { render, staticRenderFns } from "./DepositedPriceCollectionGap.vue?vue&type=template&id=1d051f4a&"
import script from "./DepositedPriceCollectionGap.vue?vue&type=script&lang=js&"
export * from "./DepositedPriceCollectionGap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports